import AuthLayout from "./AuthLayout";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import OTPInput from "react-otp-input";
import { useState } from "react";

const OtpVerification = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState<string>("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (otp.length === 4) {
      navigate("/reset-password");
    } else {
      alert("Please enter a valid 4-digit OTP");
    }
  };

  return (
    <AuthLayout>
      <div className="authBox otpBox">
        <h2 style={{ position: "relative" }}>
          <img 
            src="/static/images/back_arrow.svg" 
            alt="back" 
            onClick={() => navigate(-1)} 
            className="back_arrow"
            style={{ position: "absolute", left: 0, top: "50%", transform: "translateY(-50%)", cursor: "pointer", width: 24, height: 24 }}
          />
          Verify Phone No
        </h2>
        <p className="subtitle" style={{ marginBottom: 40 }}>
          We have sent a verification OTP to your Phone No.<br />
          Kindly check your inbox to retrieve the code.
        </p>
        <form className="form" onSubmit={handleSubmit}>
          <div className="control_group">
            <div className="opt_fields">
              <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={4}
                renderInput={(props) => <input {...props} />}
                inputType="tel"
                shouldAutoFocus
                containerStyle={{ gap: "20px", justifyContent: "center" }}
              />
            </div>
            <div className="otp_footer">
              <span className="timer">00:42</span>
              <button type="button" className="resend_link">
                Resend
              </button>
            </div>
          </div>
          <div className="form_btn">
            <Button
              type="submit"
              className="btn btn_primary w_100"
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    </AuthLayout>
  );
};

export default OtpVerification;
